import _ from "lodash";
import BaseService from "scripts/services/baseService";
import inject from "scripts/ioc/inject";
import { getCurrentFragment } from "scripts/utils/routerHelpers";

class GoogleAnalyticsService extends BaseService {
  constructor(
    deviceService = inject("deviceService"),
    securityService = inject("securityService"),
  ) {
    super();

    this.deviceService = deviceService;
    this.securityService = securityService;

    this.googleAnalyticsKey = process.env.PATRON_UI_GOOGLE_ANALYTICS_KEY;

    this.goSquaredKeyMap = {
      openresearchlibrary:
        process.env.PATRON_UI_OPEN_RESEARCH_LIBRARY_GO_SQUARED_KEY,
    };

    this.goSquaredDomainKey = this.goSquaredKeyMap[
      this.securityService.getAuthScopeFromSubdomain()
    ];
  }

  initHybrid() {
    ga("create", this.googleAnalyticsKey, {
      storage: "none",
      clientId: this.deviceService.uuid,
    });

    ga("set", "checkProtocolTask", null);
  }

  initWeb() {
    if (this.googleAnalyticsKey) {
      ga("create", this.googleAnalyticsKey, "auto", "default");
    }

    if (this.goSquaredDomainKey) {
      _gs(this.goSquaredDomainKey);
      _gs("set", "anonymizeIP", true);
    }
  }

  initDynamicTracker(keys) {
    // remove any other dynamic trackers
    ga(() => {
      ga.getAll().forEach((t) => {
        const trackerName = t.get("name");
        if (_.startsWith(trackerName, "dynamic")) {
          ga(trackerName + ".remove");
        }
      });

      if (!_.isEmpty(keys)) {
        _.split(keys, ",").forEach((key, idx) => {
          const keyName = "dynamic" + idx;
          ga("create", _.trim(key), "auto", keyName);
        });
      }
    });
  }

  sendPageView(fragment) {
    fragment = fragment || getCurrentFragment();

    const gaRoute = "/" + fragment;

    console.log(`Google Analytics page view, route: ${gaRoute}`);

    const activeOrganizationId = this.securityService
      .getUser()
      .getActiveOrganizationId();

    ga(() =>
      ga.getAll().forEach((t) => {
        t.set("dimension1", activeOrganizationId ? activeOrganizationId : null);
        t.send("pageview", gaRoute);
      }),
    );
  }

  /**
   * See https://developers.google.com/analytics/devguides/collection/analyticsjs/events
   */
  sendEvent(category, action, label, nonInteraction) {
    console.log(`Google Analytics event, category: ${category}, action: ${action}, label: ${label},
        nonInteraction: ${nonInteraction}`);

    ga(() =>
      ga.getAll().forEach((t) => {
        t.send({
          hitType: "event",
          eventCategory: category,
          eventAction: action,
          eventLabel: label,
          nonInteraction: nonInteraction,
        });
      }),
    );
  }
}

export default GoogleAnalyticsService;
